module.exports = __webpack_public_path__ + "img/icon-play-btn@2x.6a22cae9.png";